import React from 'react';
import '../component/form.css';
import PhoneImg from '../images/p.png';
import locationImg from '../images/lo.png';
import messageImg from '../images/m.png';


function Form() {
    return (
        <div className='mainDiv'>
            <div className='leftDiv'>
                <h2 className='signUp'>Sign Up</h2>
                <form className=''>
                    <div className='formInner'>
                        <label>Name</label><br/>
                        <input type='text' placeholder="Enter your name here"/></div>
                    <div className='formInner'>
                        <label>Email</label><br/>
                        <input type='email' placeholder="Enter your email here"/></div>
                    <div className='formInner'>
                        <label>Password</label><br/>
                        <input type='password' placeholder="Enter your password"/></div>
                    <button className='createButton'>Create Account</button>
                    <p className='or'>OR</p>
                    <button className='loginButton'>Log In</button>
                </form>
            </div>
            <div className='rightDiv'>
                <div className='rightInnerDiv'>
                    <h1>Any queries</h1>
                    <div className='icons'>
                        <div className='icon'><img className='img'
                                src={messageImg}/>
                            <p className='p1'>Email</p>
                        </div>
                        <div className='icon'><img className='img'
                                src={locationImg}/>
                            <pc className='p1'>Adress</pc>
                        </div>
                        <div className='icon'><img className='img'
                                src={PhoneImg}/>
                            <p className='p1'>Contact</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Form
